
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as homeWnKz8Qyy_454WwfndCBCKIwrr8Wb5kT15c2CYIuIZOp0EMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/home.vue?macro=true";
import { default as indexvJ8RqysLDCdperXEGCrhJdM_6YRWHsHQb2X2mVCBcQIMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/index.vue?macro=true";
import { default as indexnbdEotqfNYmEa6T5mVFJRCCur91d1sa7QlhJy5EEHBYMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/login/index.vue?macro=true";
import { default as _91token_931w0pfCQvs9IIFXsKJVBWyWWnMNHXZZvWA3vPO3HGvQgMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/sso/[token].vue?macro=true";
import { default as _91hash_93RW_z26jfamQ5BZiF47_jX3Q26ISxgvT9pveTqb2fn0gMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/vragen/[hash].vue?macro=true";
import { default as indexeIIPa8_454HUU_bI04CcHykPN9N5SETA4rWXEPOncWcJwMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/quickscan/index.vue?macro=true";
import { default as indexb5YAkwLRVMRlONijkPYErXKbnv_45VtasB3PSLMrOz3gEMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/onboarding/index.vue?macro=true";
import { default as indexyf2A28cg3TdQqfRMbj2A5MIba4DeQzjv3uUl3dMVcqgMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/properties/index.vue?macro=true";
import { default as adres9H_45ny1d_45nQNgqJVpPaNAlTR8nxr0t0SgC5SbQPWfysIMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/adres.vue?macro=true";
import { default as indexHNcQ7I3uRpcBMfgrt9hnaWVrf_45enr0eSLahD7mlPZScMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/index.vue?macro=true";
import { default as objectzE9l4jXrEshp6NRi0VIA16Sh2Zc2VJHIgAUzx11kmTkMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/object.vue?macro=true";
import { default as overigA2TR_4561UI0B0RJGdx4OG2rScqjC9m9A_45VVNJse7k_7gMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/overig.vue?macro=true";
import { default as indexf_9S_45QR69MOJD3NGMoqJAtR1IuurrXRqaMfPPWzUx2AMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-profiel/index.vue?macro=true";
import { default as afgeronddgvAL7hpmxjv_Fh7TwcZasuSj55qxNeyQUbtyGJdW3gMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/afgerond.vue?macro=true";
import { default as dashboardKqWCWI4nj4KLnUkfhNCNmcdrYqVRmWaY6YByHs6ioqMMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/dashboard.vue?macro=true";
import { default as beslisboomcUefyDDP2GR2pV5FQCIm99s5iJ1gY22wbo54f8OoKOIMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/beslisboom.vue?macro=true";
import { default as geldnemers0tVfOfgKNdY_uqzHwBM5hZWt9Ktu8wkHZu_RL3sDdxgMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/geldnemers.vue?macro=true";
import { default as reset_45wachtwoordi_nT_45R7F4pVOtdvngmUtVf44kK8gq_45SPbe1meTXXB64Meta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/login/reset-wachtwoord.vue?macro=true";
import { default as _91token_93t63zXRyeO7sPn6fGAtfw8TFBpwVLOVSGunXMxua8a_AMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/activeer-account/[token].vue?macro=true";
import { default as financieringSsYJSejT7qB9FXOWkRM2iSYXhJjdFHVywmNdFg9m36sMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/financiering.vue?macro=true";
import { default as ondertekenenUj0e5I_45AYsoeWbAsbn92bIfAYJmmky7xrB92xg8Wh8MMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/ondertekenen.vue?macro=true";
import { default as verklaringenb_p_45m0lGxx4SaoKxEYW1nVeHI6iAX3Pu6tbuXQz7xCQMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/verklaringen.vue?macro=true";
import { default as identificatiexhVJIwG4AojWRvO7N_DJskreE_453N9yRLwROBUqG8t9kMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/identificatie.vue?macro=true";
import { default as wachtwoord_45vergetenyKqqaS9NVHqcEOuUjQskSGH9HfssBsyKrVVD7liZ9Q4Meta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/login/wachtwoord-vergeten.vue?macro=true";
import { default as indexxFdrUgR_45NypScerIUeXvryd0YbR40cqJ9dA0ekBuSB8Meta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/index.vue?macro=true";
import { default as _91mail_93qen4oHRKNMwjxYh8RC2L3zAzCCqghHjPERsMD2rd1nQMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/[mail].vue?macro=true";
import { default as indexKVWIJjeqgpfQdAruMQvur3VNl9dpVqtZT_45lpAqYwHEoMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/portefeuille-aanvraag/index.vue?macro=true";
import { default as berichtenboxmcJRI_45L5MsskcI0auQg2bhabr5VZn_yw_3chyVn2eCIMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/berichtenbox.vue?macro=true";
import { default as indextmYuPX7apFBF49DWsi8fe6a8Gyol4_dtVfOQaErIzvgMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/documenten/index.vue?macro=true";
import { default as _91uuid_93gIsFqKyWutQLP6lZl3kCl9ReUkXKJr4v2789PKDOsVsMeta } from "/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/offerte-aanvragen/[uuid].vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    meta: homeWnKz8Qyy_454WwfndCBCKIwrr8Wb5kT15c2CYIuIZOp0EMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/home.vue")
  },
  {
    name: indexvJ8RqysLDCdperXEGCrhJdM_6YRWHsHQb2X2mVCBcQIMeta?.name ?? "index",
    path: "/",
    meta: { ...(indexvJ8RqysLDCdperXEGCrhJdM_6YRWHsHQb2X2mVCBcQIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexnbdEotqfNYmEa6T5mVFJRCCur91d1sa7QlhJy5EEHBYMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/login/index.vue")
  },
  {
    name: "sso-token",
    path: "/sso/:token()",
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/sso/[token].vue")
  },
  {
    name: "Vragen",
    path: "/vragen/:hash()",
    meta: _91hash_93RW_z26jfamQ5BZiF47_jX3Q26ISxgvT9pveTqb2fn0gMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/vragen/[hash].vue")
  },
  {
    name: "quickscan",
    path: "/quickscan",
    meta: { ...(indexeIIPa8_454HUU_bI04CcHykPN9N5SETA4rWXEPOncWcJwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/quickscan/index.vue")
  },
  {
    name: indexb5YAkwLRVMRlONijkPYErXKbnv_45VtasB3PSLMrOz3gEMeta?.name ?? "onboarding",
    path: "/onboarding",
    meta: { ...(indexb5YAkwLRVMRlONijkPYErXKbnv_45VtasB3PSLMrOz3gEMeta || {}), ...{"middleware":["auth","onboarding"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/onboarding/index.vue")
  },
  {
    name: "properties",
    path: "/properties",
    meta: {"middleware":["properties"]},
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/properties/index.vue")
  },
  {
    name: "intake-id-adres",
    path: "/intake/:id()/adres",
    meta: { ...(adres9H_45ny1d_45nQNgqJVpPaNAlTR8nxr0t0SgC5SbQPWfysIMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/adres.vue")
  },
  {
    name: "intake-id",
    path: "/intake/:id()",
    meta: { ...(indexHNcQ7I3uRpcBMfgrt9hnaWVrf_45enr0eSLahD7mlPZScMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/index.vue")
  },
  {
    name: "intake-id-object",
    path: "/intake/:id()/object",
    meta: { ...(objectzE9l4jXrEshp6NRi0VIA16Sh2Zc2VJHIgAUzx11kmTkMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/object.vue")
  },
  {
    name: "intake-id-overig",
    path: "/intake/:id()/overig",
    meta: { ...(overigA2TR_4561UI0B0RJGdx4OG2rScqjC9m9A_45VVNJse7k_7gMeta || {}), ...{"middleware":["intakeauth","admin"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/overig.vue")
  },
  {
    name: "mijn-profiel",
    path: "/mijn-profiel",
    meta: { ...(indexf_9S_45QR69MOJD3NGMoqJAtR1IuurrXRqaMfPPWzUx2AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-profiel/index.vue")
  },
  {
    name: "intake-id-afgerond",
    path: "/intake/:id()/afgerond",
    meta: { ...(afgeronddgvAL7hpmxjv_Fh7TwcZasuSj55qxNeyQUbtyGJdW3gMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/afgerond.vue")
  },
  {
    name: "intake-dashboard",
    path: "/intake/:id()/dashboard",
    meta: { ...(dashboardKqWCWI4nj4KLnUkfhNCNmcdrYqVRmWaY6YByHs6ioqMMeta || {}), ...{"middleware":["intakeauth","dashboard"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/dashboard.vue")
  },
  {
    name: "intake-id-beslisboom",
    path: "/intake/:id()/beslisboom",
    meta: { ...(beslisboomcUefyDDP2GR2pV5FQCIm99s5iJ1gY22wbo54f8OoKOIMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/beslisboom.vue")
  },
  {
    name: "intake-id-geldnemers",
    path: "/intake/:id()/geldnemers",
    meta: { ...(geldnemers0tVfOfgKNdY_uqzHwBM5hZWt9Ktu8wkHZu_RL3sDdxgMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/geldnemers.vue")
  },
  {
    name: "login-reset-wachtwoord",
    path: "/login/reset-wachtwoord",
    meta: reset_45wachtwoordi_nT_45R7F4pVOtdvngmUtVf44kK8gq_45SPbe1meTXXB64Meta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/login/reset-wachtwoord.vue")
  },
  {
    name: "activeer-account-token",
    path: "/activeer-account/:token()",
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/activeer-account/[token].vue")
  },
  {
    name: "intake-id-financiering",
    path: "/intake/:id()/financiering",
    meta: { ...(financieringSsYJSejT7qB9FXOWkRM2iSYXhJjdFHVywmNdFg9m36sMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/financiering.vue")
  },
  {
    name: "intake-id-ondertekenen",
    path: "/intake/:id()/ondertekenen",
    meta: { ...(ondertekenenUj0e5I_45AYsoeWbAsbn92bIfAYJmmky7xrB92xg8Wh8MMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/ondertekenen.vue")
  },
  {
    name: "intake-id-verklaringen",
    path: "/intake/:id()/verklaringen",
    meta: { ...(verklaringenb_p_45m0lGxx4SaoKxEYW1nVeHI6iAX3Pu6tbuXQz7xCQMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/verklaringen.vue")
  },
  {
    name: "intake-id-identificatie",
    path: "/intake/:id()/identificatie",
    meta: { ...(identificatiexhVJIwG4AojWRvO7N_DJskreE_453N9yRLwROBUqG8t9kMeta || {}), ...{"middleware":["intakeauth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/layers/intake/pages/intake/[id]/identificatie.vue")
  },
  {
    name: "login-wachtwoord-vergeten",
    path: "/login/wachtwoord-vergeten",
    meta: wachtwoord_45vergetenyKqqaS9NVHqcEOuUjQskSGH9HfssBsyKrVVD7liZ9Q4Meta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/login/wachtwoord-vergeten.vue")
  },
  {
    name: "Mijn aanvraag",
    path: "/mijn-aanvragen/:id()",
    meta: { ...(indexxFdrUgR_45NypScerIUeXvryd0YbR40cqJ9dA0ekBuSB8Meta || {}), ...{"middleware":["auth","dossier"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/index.vue")
  },
  {
    name: "Email",
    path: "/mijn-aanvragen/:id()/:mail()",
    meta: { ...(_91mail_93qen4oHRKNMwjxYh8RC2L3zAzCCqghHjPERsMD2rd1nQMeta || {}), ...{"middleware":["auth","dossier","email"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/[mail].vue")
  },
  {
    name: "portefeuille-aanvraag",
    path: "/portefeuille-aanvraag",
    meta: { ...(indexKVWIJjeqgpfQdAruMQvur3VNl9dpVqtZT_45lpAqYwHEoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/portefeuille-aanvraag/index.vue")
  },
  {
    name: "Berichtenbox",
    path: "/mijn-aanvragen/:id()/berichtenbox",
    meta: { ...(berichtenboxmcJRI_45L5MsskcI0auQg2bhabr5VZn_yw_3chyVn2eCIMeta || {}), ...{"middleware":["auth","dossier"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/berichtenbox.vue")
  },
  {
    name: "Documenten",
    path: "/mijn-aanvragen/:id()/documenten",
    meta: { ...(indextmYuPX7apFBF49DWsi8fe6a8Gyol4_dtVfOQaErIzvgMeta || {}), ...{"middleware":["auth","dossier"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/documenten/index.vue")
  },
  {
    name: "Offerte aanvragen",
    path: "/mijn-aanvragen/:id()/offerte-aanvragen/:uuid()",
    meta: { ...(_91uuid_93gIsFqKyWutQLP6lZl3kCl9ReUkXKJr4v2789PKDOsVsMeta || {}), ...{"middleware":["auth","dossier"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250731135815/packages/intermediairs/pages/mijn-aanvragen/[id]/offerte-aanvragen/[uuid].vue")
  }
]